import { render, staticRenderFns } from "./assigned-studies.vue?vue&type=template&id=32f5687d&scoped=true&"
import script from "./assigned-studies.vue?vue&type=script&lang=js&"
export * from "./assigned-studies.vue?vue&type=script&lang=js&"
import style0 from "@/assets/dot-streaching-loader.scss?vue&type=style&index=0&id=32f5687d&scoped=true&lang=scss&"
import style1 from "./assigned-studies.vue?vue&type=style&index=1&id=32f5687d&scoped=true&lang=scss&"
import style2 from "./assigned-studies.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f5687d",
  null
  
)

component.options.__file = "assigned-studies.vue"
export default component.exports